module.exports = __webpack_public_path__ + "img/perou.a17d8493.jpg";